<template>
  <div v-loading="loading">
    <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="用户填写列表" name="list"></el-tab-pane>
      <el-tab-pane label="表单" name="form"></el-tab-pane>
      <el-tab-pane label="自定义字段" name="field"></el-tab-pane>
    </el-tabs>

    <List v-if="activeName == 'list'"></List>
    <Form v-if="activeName == 'form'"></Form>
    <Field v-if="activeName == 'field'"></Field>
    <!--分销商条件-->
    <!-- <License v-if="activeName == 'license'" :settingData="settingData"></License> -->

  </div>
</template>
<script>
import List from './list/index.vue';
import Form from './form/index.vue';
import Field from './field/index.vue';
export default {
  components: {
    List,
    Form,
    Field
  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      form: {
        status: 0
      },
      activeName: 'list',
      /*数据对象*/
      settingData:{},
      gradeList: [],
      is_load: false,
    };
  },
  created() {
    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }else{
      // 默认
      let tabs = this.$db.getRouteField(this, 'tabs');
      if (tabs) this.activeName = tabs;
    }
    // this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      SettingApi.getSetting({}, true)
        .then(res => {
          self.settingData = res.data;
          self.gradeList = res.data.gradeList;
          self.loading=false;

          // 默认
          let tabs = self.$db.getRouteField(self, 'tabs');
          if (tabs) self.activeName = tabs;

          self.$forceUpdate();
          self.is_load = true;
        })
        .catch(error => {});
    },
    handleClick(e) {
      this.activeName = e.name;
      this.$db.setRoute(this, {'tabs': e.name});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/custom/index.vue